import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/views/Home.vue';
import MonitorPage from '@/views/MonitorPage.vue';
import AuthView from '@/views/AuthView.vue';

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		meta: { requiresAuth: true },
	},
  {
    path: '/monitoreo',
    name: 'Monitoreo',
    component: MonitorPage,
	meta: { requiresAuth: true },
  },
  {
    path: '/login',
    name: 'login',
    component: AuthView
  },
];

const router = createRouter({
	history: createWebHashHistory(),
	mode: 'hash',
	routes
  });

export default router;
